function swipe() {
    if (typeof window !== 'undefined') {
        require('jquery-touchswipe');
    }

    $(".carousel").swipe({
        swipe: function (event, direction) {
            if (direction === 'left') $(this).carousel('next');
            if (direction === 'right') $(this).carousel('prev');
        },
        allowPageScroll: "vertical"
    });
}

export default swipe;
